import { replacePlaceholderTagsInHtmlString } from '@/utils/unlayer';

const NON_TEXT_CONTENT_SELECTOR = 'img,svg,video,canvas,table,iframe,hr';

const stripUnsafeNodes = (documentBody) => {
	documentBody.querySelectorAll('script,style,noscript').forEach((node) => node.remove());
};

/**
 * Removes obviously empty exported markup so save validation can treat placeholder-only
 * Unlayer output the same way a user would: as an empty signature.
 */
export const normalizeSignatureHtmlForValidation = (html) => {
	if (typeof html !== 'string' || html.trim().length === 0) {
		return '';
	}

	const document = new DOMParser().parseFromString(html, 'text/html');
	stripUnsafeNodes(document.body);

	const normalizedHtml = document.body.innerHTML.trim();
	if (normalizedHtml.length === 0) {
		return '';
	}

	const normalizedText = (document.body.textContent ?? '')
		.replace(/\u00a0/g, ' ')
		.replace(/[\u200B-\u200D\uFEFF]/g, '')
		.replace(/\s+/g, ' ')
		.trim();
	const hasVisibleText = normalizedText.length > 0;
	const hasNonTextContent = Boolean(document.body.querySelector(NON_TEXT_CONTENT_SELECTOR));

	return hasVisibleText || hasNonTextContent ? normalizedHtml : '';
};

export const isSignatureHtmlEmpty = (html) =>
	normalizeSignatureHtmlForValidation(html).length === 0;

/**
 * Resolves merge tags into their frozen snapshot values, then applies the same
 * emptiness normalization used by validation so we store exactly what will be inserted later.
 */
export const resolveSignatureSnapshotHtml = ({ html, tagData }) =>
	normalizeSignatureHtmlForValidation(replacePlaceholderTagsInHtmlString(html, tagData));
